<template>
    <v-container>
        <Loading :value="loading" ></Loading>
        <el-steps :active="active" align-center simple>
            <el-step title="Informations"   icon="el-icon-edit"></el-step>
            <el-step title="Salaire"   icon="el-icon-edit"></el-step>
            <el-step title="Fichier"   icon="el-icon-edit"></el-step>
        </el-steps>

        <el-form id="formContrat" :rules="rules" label-position="top" ref="formContrat"  :model="formContrat" class="demo-ruleForm" >

                <el-card class="box-card" v-if="active == 0">
                    <el-row type="flex" :gutter="20">
                        <el-col :span="6">

                                <el-form-item label="Type de contrat" prop="typeContrat">
                                    <el-select v-model="formContrat.idTypeCont" placeholder="Type de contrat">
                                        <el-option v-for="(item,index) in listeTypeContrat" :key=index :label="item.libelle" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>

                        </el-col>

                        <el-col :span="6">
                            <el-form-item label="Date début" prop="dateSignature">
                                <el-date-picker
                                        format="d-MM-yyyy"
                                        v-model="formContrat.dateSignature"
                                        placeholder="Date de signature"
                                        type="date"
                                        @change="verifDateContCDI"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>

                        <el-col :span="6" v-if="formContrat.idTypeCont != 9">
                            <el-form-item label="Date de fin">
                                <el-date-picker
                                        format="d-MM-yyyy"
                                        v-model="formContrat.dateFin"
                                        placeholder="Date de fin"
                                        type="date"
                                        @change="verifDate"

                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>

                        <el-col :span="6">
                            <el-form-item
                            label="Poste" prop="libPoste">
                                <el-select clearable allow-create filterable v-model="formContrat.libPoste" placeholder="Type de poste">
                                    <el-option v-for="(item,index) in listePoste" :key=index :label="item.libelle" :value="item.libelle"></el-option>
                                </el-select>
                            </el-form-item>

                        </el-col>


                    </el-row>

                    <el-row type="flex" :gutter="20" >
                        <el-col :span="6">
                            <div>
                                <el-form-item label="Projet concerné">
                                    <el-select  clearable filterable  v-model="formContrat.idProjet" placeholder="Projet concerné">
                                        <el-option v-for="(item,index) in listeProjets" :key=index :label="item.libelle" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>

                        <el-col :span="6">

                                <el-form-item label="Superviseur" >
                                        <el-select  clearable filterable  v-model="formContrat.superviseur" placeholder="Projet concerné">
                                            <el-option v-for="(item,index) in listeUser" :key=index :label="item.libelle" :value="item.id"></el-option>
                                        </el-select>
                                </el-form-item>

                        </el-col>

                        <el-col :span="11">

                                <el-form-item label="Description">
                                    <el-input placeholder="Description"  :rows="6" type="textarea"  v-model="formContrat.description"></el-input>
                                </el-form-item>

                        </el-col>
                    </el-row>
                </el-card>


            <!--taux de paiement-->
            <el-card class="box-card" v-if="active == 1">
                <el-row type="flex" :gutter="20">
                    <el-col :span="6">
                        <el-form-item label="Paiement">
                            <el-select v-model="formContrat.tauxPaiement" placeholder="Taux de paiement">
                                <el-option v-for="(item,index) in listeTauxPaiement" :key=index :label="item.libelle" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">

                        <el-form-item label="Type de paie">
                            <el-select v-model="formContrat.typePaie" placeholder="Type de paie">
                                <el-option v-for="(item,index) in listeTypePaie" :key=index :label="item.libelle" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>

                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="Rénumération">
                            <el-input-number v-model="formContrat.renumeration"  :min="1" ></el-input-number>
                        </el-form-item>

                    </el-col>

                    <el-col :span="6">
                        <div>
                            <el-form-item label="Statut de temps supplémentaire">
                                <el-select v-model="formContrat.statut" placeholder="Statut de temps">
                                    <el-option v-for="(item,index) in listeStatut" :key=index :label="item.libelle" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-card>

            <!--Fichiers-->
            <el-card class="box-card" v-if="active == 2">
                <el-row type="flex" :gutter="20">
                    <el-col :span="24">
                        <el-upload class="upload-demo"
                                    list-type="picture-card"
                                    name="photo" action=""
                                    ref="uploadFichContrat"
                                    :auto-upload="false"
                                    :on-change = "changeFile"
                                    :multiple="true"  >
                            <img height="142" width="142" src="" class="lazy" alt="">
                        </el-upload>
                    </el-col>
                </el-row>
            </el-card>


            <el-row justify="end">

                <el-col :span="24" >
                    <div class="text-xs-right" >
                        <v-btn
                                v-if="active!=0"
                                color="primary"
                                @click="previous"
                        >

                            Précédent
                        </v-btn>

                        <v-btn
                                v-if="active!=2"
                                color="primary"
                                @click="next"
                                :disabled="isInvalide"
                        >
                            Suivant

                        </v-btn>

                        <v-btn
                                v-if="active==2"
                                dark
                                color="green"
                                @click="submitForm('formContrat')"
                        >

                            Enregistrer
                            <v-icon right dark>save</v-icon>
                        </v-btn>
                    </div>
                </el-col>




            </el-row>

        </el-form>

    </v-container>
</template>

<script>
    import Loading from '@/components/Loading';
    export default {
        props:{
            idUserContrat: {
                type: Number
            },
        },
        components: {Loading},
        name: "formContrat",
        data(){
            return{
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,

                formContrat:{
                    idTypeCont:1,
                    renumeration: 5,
                    libPoste:'',
                    statut: 0,
                    typePaie: 1,
                    tauxPaiement: 2,
                    dateFin: null
                },
                listeProjets:[],
                active: 0,
                listeStatut:[
                    {
                        libelle: "non",
                        id: 0
                    },
                    {
                        libelle: "exempt",
                        id: 1
                    },

                ],
                listeTauxPaiement:[
                    {
                        libelle: "Heure",
                        id: 1
                    },
                    {
                        libelle: "Mois",
                        id: 2
                    },
                    {
                        libelle: "Semaine",
                        id: 3
                    },
                    {
                        libelle: "Annee",
                        id: 4
                    },
                ],
                listeTypePaie:[
                    {
                        libelle: "Salaire",
                        id: 1
                    },
                    {
                        libelle: "Heure",
                        id: 2
                    },
                    {
                        libelle: "Contrat",
                        id: 3
                    },
                    {
                        libelle: "Commission",
                        id: 4
                    },
                ],
                listeTypeContrat:[
                    {
                        libelle:"Stagiaire formation",
                        id:1
                    },
                    {
                        libelle:"Stagiaire Professionnel",
                        id:3
                    },
                    {
                        libelle:"Temps partiel",
                        id:5
                    },
                    {
                        libelle:"Consultant",
                        id:7
                    },
                    {
                        libelle:"CDI",
                        id:9
                    },
                    {
                        libelle:"CDD",
                        id:11
                    },
                ],
                listePoste:[],
                listeUser:[],
                listePhotos:[],
                rules:{
                    dateSignature: [
                        { type: 'date', required: true, message: 'Veuillez selectionnez une date', trigger: 'blur' }
                    ],
                    libPoste: [
                        {required:true, message: "Veuillez saisir ou selectionnez le poste",trigger: 'blur' }
                    ],
                    typeContrat: [
                        {required:true, message: "Veuillez  selectionnez le type de contrat",trigger: 'blur' }
                    ],

                },
                dateInvalide: true,
                nextEtatContrat: 0, //contrat en cours par defaut

            }
        },
        methods:{
            //que la date de debut est toujours superieur a la date fin
            verifDate(){
                if(this.formContrat.dateSignature.getTime() >= this.formContrat.dateFin.getTime())
                {
                    this.dateInvalide = true;
                    this.formContrat.dateSignature = null;
                    this.formContrat.dateFin = null;

                    this.$alert('La début doit être strictement inférieur à la date de fin du contrat', 'Validation champs date', {
                        confirmButtonText: 'OK',
                    });
                }
                else{
                    //Verifier si le contrat peut etre creer
                    this.loading = true;
                    let url = this.domaine + 'rh/verification/contrat/employe/'+this.idUserContrat;
                    let tabDbt = new Intl.DateTimeFormat('en-GB').format(this.formContrat.dateSignature).split("/")
                    let tabFin = new Intl.DateTimeFormat('en-GB').format(this.formContrat.dateFin).split("/")

                    let data = {
                        dateDbt: tabDbt[2]+"-"+tabDbt[1]+"-"+tabDbt[0],
                        dateFin: tabFin[2]+"-"+tabFin[1]+"-"+tabFin[0],
                        typeContrat: this.formContrat.idTypeCont
                    };

                    this.$http.get(url,{params: data}).then(resp=>{
                        this.loading = false;
                        if(resp.body.code == 0) //le contrat ne peut etre creer
                        {
                            this.formContrat.dateFin = null;
                            this.formContrat.dateSignature = null;
                            this.dateInvalide = true;
                            this.$alert(resp.body.message, 'Validation champs date', {
                                confirmButtonText: 'OK',
                            });
                            return;
                        }
                        this.dateInvalide = false;
                        this.nextEtatContrat = resp.body.etatContrat

                    }, error =>{
                        this.loading = false;
                        this.formContrat.dateFin = null;
                        this.dateInvalide = true;
                        this.$message.error("Une erreur sest produite lors de la validation des champs dates")

                    });


                }
            },
            verifDateContCDI(){

                if( (this.formContrat.idTypeCont == 9) && this.formContrat.dateSignature != null)
                {
                    //Verifier si le contrat peut etre creer
                    this.loading = true;
                    let url = this.domaine + 'rh/verification/contrat/employe/'+this.idUserContrat;
                    let tabDbt = new Intl.DateTimeFormat('en-GB').format(this.formContrat.dateSignature).split("/")
                    let data = {
                        dateDbt: tabDbt[2]+"-"+tabDbt[1]+"-"+tabDbt[0],
                        dateFin: null,
                        typeContrat: this.formContrat.idTypeCont
                    }

                    this.$http.get(url,{params: data}).then(resp=>{
                        this.loading = false;
                        if(resp.body.code == 0) //le contrat ne peut etre creer
                        {
                            this.formContrat.dateFin = null;
                            this.formContrat.dateSignature = null;
                            this.dateInvalide = true;
                            this.$alert(resp.body.message, 'Validation champs date', {
                                confirmButtonText: 'OK',
                            });
                            return;
                        }
                        this.dateInvalide = false;
                        this.nextEtatContrat = resp.body.etatContrat

                    }, error =>{
                        this.loading = false;
                        this.formContrat.dateFin = null;
                        this.dateInvalide = true;
                        this.$message.error("Une erreur sest produite lors de la validation des champs dates")

                    });
                }

            },
            verifInformation()
            {
                if(this.formContrat.idTypeCont == null || this.formContrat.dateSignature == null || this.formContrat.libPoste == ""){
                    this.$message.error("Veuillez remplir correctement les champs svp")
                    return false;
                }
                else {
                    return true;
                }
            },
            changeFile(file,fileList){
                this.listePhotos.splice(0);
                const fileReader = new FileReader()

                for (const ind in fileList){
                    let filename = fileList[ind].name;
                    if( filename.lastIndexOf(".") <= 0 ){
                        return alert("Veuillez selectionner un  format de fichier valide ")
                    }
                    //fileReader.readAsDataURL(fileList[ind].raw)
                    this.listePhotos.push(fileList[ind].raw);
                }
            },
            next() {
                if (this.active++ > 1) this.active = 1;
            },
            previous() {
                if (this.active-- < 0 ) this.active = 0;
            },
            successNotif(mess = ""){
                this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: mess,
                    type: 'success',
                    position: 'top-center'
                })
            },

            submitForm()
            {
                        if (!this.verifInformation() ){
                            this.active= 0;
                            return;
                        }

                        this.loading = true;
                        let url = this.domaine + 'rh/new/contrat/user/'+this.idUserContrat
                        let data = new FormData();
                        data.append("dataForm", JSON.stringify(this.formContrat))

                        data.append("idCreatedUser", this.user.id)
                        if (this.listePhotos.length > 0) {
                            this.listePhotos.forEach(file => {
                                data.append("fichierImage[]", file, file[name]);
                            }, this);
                        }

                        this.$http.post(url,data).then(response => {
                                this.active= 0;
                                this.resetFormContrat()
                                this.closeForm();
                                this.loading = false
                                this.successNotif(response.body.message)

                            },
                            error =>{
                                this.loading = false;
                                this.$message.error("Echec lors de l'enregistrement du contrat")
                            })

                },




            loadListeProjet(){
                let url = this.domaine + 'projet/liste';
                this.$http.get(url).then(resData => {
                        this.listeProjets= resData.body.listeProjets;
                    },
                    error =>{
                        this.loading = false;
                        this.$message.error("Echec lors du chargement de la liste des projets")
                    })
            },

            loadTypeContrat(){
                let url = this.domaine + 'rh/listeTypeConge';
                this.$http.get(url).then(resData => {
                        this.listeTypeConge = resData.body.listeAbsences;
                    },
                    error =>{
                        this.loading = false;
                        this.$message.error("Echec lors du chargement de al liste des type de conges")
                    })
            },
            loadUser(){
                let url = this.domaine + 'rh/users/listeUtilitsateur';
                this.$http.get(url).then(resData => {
                        this.listeUser= resData.body.listeUsers;
                    },
                    error =>{
                        this.loading = false;
                        this.$message.error("Echec lors du chargement de al liste des superviseurs")
                    })
            },
            loadPoste(){},
            closeForm(){
                this.$emit("close");
            },
            //reinitialise le formulaire de creation de contrat
            resetFormContrat(){
               this.formContrat.idTypeCont =''
               this.formContrat.dateSignature =''
               this.formContrat.dateFin =''
               this.formContrat.idProjet =''
               this.formContrat.superviseur =''
               this.formContrat.description =''
               this.formContrat.tauxPaiement =''
               this.formContrat.typePaie =''
               this.formContrat.renumeration =''
               this.formContrat.statut =''
            }
        },
        computed:{
            isInvalide(){
                if( (this.dateInvalide  == true && this.formContrat.idTypeCont != 9) ||  this.formContrat.libPoste == "" || this.formContrat.dateSignature == null ) {
                    return true
                }
                else {
                    return false
                }
            }
        },


        mounted(){
            this.loadListeProjet()
            this.loadTypeContrat()
            this.loadPoste()
            this.loadUser()
        }
    }
</script>

<style scoped>
    /*.el-form-item__content {*/
        /*width: 70%;*/
    /*}*/

    .el-upload, .el-upload-dragger {
        width: 30% !important;
        height: 150px! important;
    }
</style>



// WEBPACK FOOTER //
// src/components/resourceHumaine/form_contrat.vue